module.exports = __webpack_public_path__ + "img/facematch.18b11150.svg";